import React, { useEffect, useState } from "react";
import { ReactTyped } from "react-typed";

const Intro = () => {
  const [animationFinished, setAnimationFinished] = useState(false);
  const [animationFinished2, setAnimationFinished2] = useState(true);
  const [animationFinished3, setAnimationFinished3] = useState(true);

  useEffect(() => {
    const timeout2 = setTimeout(() => {
      setAnimationFinished2(false);
    }, 50);

    const timeout = setTimeout(() => {
      setAnimationFinished(true);
    }, 7000);

    const timeout3 = setTimeout(() => {
      setAnimationFinished3(false);
    }, 8000);

    return () => {
      clearTimeout(timeout);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
    };
  }, []);

  return (
    <div
      className={`fixed bg-gradient-to-bl from-stone-800 via-black to-slate-800 z-50 left-0 top-0 w-screen h-screen  transition-opacity duration-1000 flex justify-center items-center ${
        animationFinished ? "opacity-0" : " opacity-100"
      }
        ${animationFinished3 ? "" : "hidden"}`}
    >
      {/* <img src="https://res.cloudinary.com/dd6sontgf/image/upload/v1716651456/offd88w9yn7psrmwm73w.jpg" className="absolute top-0 left-0 h-screen w-screen" /> */}
      <h1 className=" max-w-[90%] flex justify-center items-center  text-center">
        <div
          className={` w-full bg-transparent flex flex-col gap-y-2  justify-center items-center scale-0 duration-1000 transition-all ${
            animationFinished2
              ? "scale-[0.5]"
              : "scale-[1] transition-all duration-500"
          } ${
            animationFinished
              ? " opacity-0 -translate-y-[-50vh]"
              : " translate-y-[0vh] scale-100 opacity-100"
          }`}
        >
          <ReactTyped
            className=" bg-transparent font-poppins font-bold text-white text-5xl text-wrap"
            strings={[`Shubham Baban Shinde`]}
            typeSpeed={20}
            backSpeed={50}
          ></ReactTyped>
          <br />
          <ReactTyped
            className=" bg-transparent font-poppins font-bold text-white text-3xl text-wrap"
            startDelay={1000}
            strings={[
              `<div className = "text-sm">${process.env.REACT_APP_TAG_INTRO}</div>`,
            ]}
            typeSpeed={20}
            backSpeed={50}
          ></ReactTyped>
        </div>
      </h1>
    </div>
  );
};

export default Intro;
